export default "__VITE_ASSET__Cotk5nkc__"